import React, { useState } from 'react';
import {
  Divider,
  Popover,
  PopoverProvider,
  PopoverTrigger,
  TextStatus,
  ToolkitFeatureFlag,
  Tooltip,
  ModalProvider,
  ModalTrigger,
} from '@cko/primitives';
import { useSignout, useUserLevelSettings } from '@cko/dashboard-shared';

import { useNavigation } from '../../../providers/NavigationProvider';
import { Cog } from '../../../utils/MenuIcons/Cog';
import { AccountDetailsModal } from './AccountDetailsModal';
import {
  Button,
  MenuLink,
  StyledNameContainer,
  StyledNameText,
  SignOutButton,
  StyledUserAvatar,
  StyledNameAndRoleContainer,
  StyledLinksContainer,
  StyledPopoverContent,
  AccountDetailsButton,
} from './SettingsMenuButton.styles';

export const SettingsMenuButton = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAccountDetailsModalOpen, setIsAccountDetailsModalOpen] = useState(false);
  const { currentUser } = useUserLevelSettings();
  const { getRouteById } = useNavigation();
  const { signout } = useSignout();

  if (!currentUser) {
    return null;
  }

  const { current_role_names: roles, fullName } = currentUser;

  const settingsPath = getRouteById('settings')?.path;

  const onSignOutClick = () => {
    signout();
    setIsMenuOpen(false);
  };

  return (
    <ToolkitFeatureFlag flag="v10">
      <PopoverProvider open={isMenuOpen} onOpenChange={() => setIsMenuOpen(!isMenuOpen)}>
        <Tooltip text="Settings menu" defaultDirection="bottom-start">
          <PopoverTrigger>
            <Button
              aria-label="Settings menu"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <Cog />
            </Button>
          </PopoverTrigger>
        </Tooltip>
        <Popover>
          <ModalProvider
            open={isAccountDetailsModalOpen}
            onOpenChange={() => setIsAccountDetailsModalOpen((open) => !open)}
          >
            <StyledPopoverContent>
              <StyledNameAndRoleContainer>
                <StyledUserAvatar>{fullName[0]}</StyledUserAvatar>
                <StyledNameContainer>
                  <StyledNameText>{fullName}</StyledNameText>
                  <TextStatus>{roles[0]}</TextStatus>
                </StyledNameContainer>
              </StyledNameAndRoleContainer>
              <Divider />
              <StyledLinksContainer>
                {settingsPath && (
                  <MenuLink onClick={() => setIsMenuOpen(false)} role="link" to={settingsPath}>
                    Settings
                  </MenuLink>
                )}
                <ModalTrigger>
                  <AccountDetailsButton
                    onClick={() => {
                      setIsAccountDetailsModalOpen(true);
                    }}
                  >
                    Account details
                  </AccountDetailsButton>
                </ModalTrigger>
                <SignOutButton onClick={onSignOutClick}>Sign out</SignOutButton>
              </StyledLinksContainer>
            </StyledPopoverContent>
            <AccountDetailsModal />
          </ModalProvider>
        </Popover>
      </PopoverProvider>
    </ToolkitFeatureFlag>
  );
};
